<template>
	<div class="product-price overflow-hidden">
		<span v-if="displaySaleAmount" class="sale-amount">{{ formattedSaleAmount }}</span
		><span v-if="displayAmount" class="amount">{{ formattedAmount }}</span
		><span v-if="displayInterval" class="price-interval">/{{ formattedInterval }}</span>
		<div class="flexible-pay-banner" v-if="isStanFlexiblePaymentAvailable && showFlexiblePrice">
			{{ stanFlexiblePaymentHeader }}
		</div>
	</div>
</template>
<script>
	import { formatCurrency, PRICE_INTERVAL_LIST } from './utils'
	import Il8nMixin from './Il8nMixin'
	export default {
		mixins: [Il8nMixin],
		props: {
			currency: { type: String, default: 'USD' },
			saleAmount: { type: [Number, String], default: undefined },
			amount: { type: Number, default: undefined },
			interval: { type: String, default: undefined },
			stanFlexiblePaymentPrice: { type: Object, default: () => {} },
			showFlexiblePrice: { type: Boolean, default: false }, // For Experiment
		},
		computed: {
			displayAmount() {
				return this.amount && this.amount > 0
			},
			displaySaleAmount() {
				return this.saleAmount && this.saleAmount > 0
			},
			displayInterval() {
				return this.amount && this.interval
			},
			formattedAmount() {
				return formatCurrency(parseFloat(this.amount), this.currency)
			},
			formattedSaleAmount() {
				return formatCurrency(parseFloat(this.saleAmount || 0), this.currency)
			},
			formattedInterval() {
				if (this.interval) {
					const intervalLowerCase = this.interval.toLowerCase()
					if (PRICE_INTERVAL_LIST.includes(intervalLowerCase)) {
						return this.$t(`shared.price.interval.${intervalLowerCase}`)
					} else {
						return intervalLowerCase.charAt(0).toUpperCase() + intervalLowerCase.slice(1)
					}
				}
			},
			isStanFlexiblePaymentAvailable() {
				return !!this.stanFlexiblePaymentPrice?.enabled
			},
			stanFlexiblePaymentHeader() {
				// Added check for recurring price to avoid showing the banner for flexible payment prices
				if (!this.isStanFlexiblePaymentAvailable || this.displayInterval || !(this.displayAmount || this.displaySaleAmount)) {
					return ''
				}
				const grossAmount = this.stanFlexiblePaymentPrice.amount / this.stanFlexiblePaymentPrice.duration
				const grossAmountPerPeriod = formatCurrency(parseFloat(grossAmount), this.currency)
				const wordMap = {
					day: 'daily',
					week: 'weekly',
					'bi-week': 'biweekly',
					month: 'monthly',
					year: 'annual',
				}

				return `Or ${this.stanFlexiblePaymentPrice?.duration} ${
					wordMap[this.stanFlexiblePaymentPrice?.interval]
				} payments of ${grossAmountPerPeriod}`
			},
		},
	}
</script>
<style lang="scss" scoped>
	.product-price {
		span:first-child {
			color: var(--stan-store-theme-primary-color, var(--stan-user-primary-color, var(--stan-store-default-color)));
			margin-right: 5px;
		}

		span:nth-child(2) {
			color: #cad1e1;
			text-decoration: line-through;
			margin-right: 5px;
		}

		span.price-interval {
			color: var(--stan-store-theme-primary-color, var(--stan-user-primary-color, var(--stan-store-default-color)));
			text-decoration-line: none !important;
		}
	}

	.flexible-pay-banner {
		color: var(--stan-store-theme-primary-text-color);
		font-size: 16px;
		opacity: 0.6;
		font-weight: 500;
		margin-bottom: 10px;
	}
</style>
